// TO-DO: Set where in all api calls for filters so only matched with genre are rendered,
//        'cause no point of showing data that doesnt exist in specific genre

import React, { useEffect, useState, useContext } from "react";
import { Link, useParams, useHistory } from "react-router-dom";

// Bootstrap Components
import Row from "react-bootstrap/Row";

// Context
import AlertContext from "../context/AlertContext";
import { useLocation } from "../context/LocationContext";

// API
import { getGenreProducts, getAllGenreProducts } from "../api/product";
import { getGenre } from "../api/genre";

// Custom Components
import ProductCard from "../components/ProductCard/ProductCard";
import CustomPagination from "../components/Pagination/Pagination";
import PriceRangeSlider from "../components/PriceRangeSlider/PriceRangeSlider";

// Custom styles
import "../assets/scss/pages/genre.scss";

// Util
import { toggleClass } from "../utils/toggleClass";

// Assets
import FilterIcon from "../assets/images/filter-icon.svg";

export default function Genre() {
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [loadingGenre, setLoadingGenre] = useState(true);
  const [products, setProducts] = useState(null);
  const [genre, setGenre] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Mobile filter state
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const alert = useContext(AlertContext);
  const { userCountry } = useLocation();

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Mobile filter toggle handler
  const handleMobileFilterToggle = () => {
    setIsMobileFilterOpen(!isMobileFilterOpen);
  };

  // Extract filter options from products data
  const getUniqueWatchBands = () => {
    if (!allProducts || allProducts.length === 0) return [];
    const uniqueBands = [...new Set(allProducts.map(product => product.tipoCorrea?.nombre).filter(Boolean))];
    return uniqueBands.sort();
  };

  const getUniqueBrands = () => {
    if (!allProducts || allProducts.length === 0) return [];
    const uniqueBrands = [...new Set(allProducts.map(product => product.marca?.nombre).filter(Boolean))];
    return uniqueBrands.sort();
  };

  const getUniqueWatchTypes = () => {
    if (!allProducts || allProducts.length === 0) return [];
    const uniqueTypes = [...new Set(allProducts.map(product => product.tipo?.nombre).filter(Boolean))];
    return uniqueTypes.sort();
  };

  const getUniqueWatchCalibers = () => {
    if (!allProducts || allProducts.length === 0) return [];
    const uniqueCalibers = [...new Set(allProducts.map(product => product.calibre?.nombre).filter(Boolean))];
    return uniqueCalibers.sort();
  };

  const getUniqueWatchConditions = () => {
    if (!allProducts || allProducts.length === 0) return [];
    const uniqueConditions = [...new Set(allProducts.map(product => product.condicion?.nombre).filter(Boolean))];
    return uniqueConditions.sort();
  };

  const getUniqueCaratulas = () => {
    if (!allProducts || allProducts.length === 0) return [];
    const uniqueCaratulas = [...new Set(allProducts.map(product => product.colorCaratula?.color).filter(Boolean))];
    return uniqueCaratulas.sort();
  };

  const getUniqueCarcasas = () => {
    if (!allProducts || allProducts.length === 0) return [];
    const uniqueCarcasas = [...new Set(allProducts.map(product => product.materialCarcasa?.material).filter(Boolean))];
    return uniqueCarcasas.sort();
  };

  let state = {
    userInputContainerClicked: false,
    searchTerm: "",
    passingTags: {
      search: {
        inputTerm: "",
      },
      price: {
        lowHigh: false,
        highLow: false,
      },
      calibre: {},
      tipoCorrea: {},
      marca: {},
      tipo: {},
      condicion: {},
      caratula: {},
      carcasa: {},
    },
  };

  const [allProducts, setAllProducts] = useState([]);
  const [testinState, setTestingState] = useState(state);
  const [categories, setCategories] = useState([]);

  const [loadingWatchCalibers, setLoadingWatchCalibers] = useState(true);
  const [priceRange, setPriceRange] = useState(null);
  const [filterResetTrigger, setFilterResetTrigger] = useState(0);
  const [loadingWatchConditions, setLoadingWatchConditions] = useState(true);
  const [watchConditions, setWatchConditions] = useState([]);

  // Add state for dropdown toggles
  const [openDropdowns, setOpenDropdowns] = useState({
    correa: false,
    marca: false,
    condicion: false,
    tipo: false,
    calibre: false,
    caratula: false,
    carcasa: false,
  });

  // Toggle dropdown function
  const toggleDropdown = (dropdownName) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [dropdownName]: !prev[dropdownName]
    }));
  };

  // Fetch products for the current page (server-side pagination)
  useEffect(() => {
    const fetchGenreProducts = async () => {
      setLoading(true);
      try {
        // Fetch products for current page with server-side pagination
        const response = await getGenreProducts(slug, currentPage, 12, userCountry);

        if (response?.error) {
          console.error("Error fetching genre products:", response.message);
          alert.error("Hubo un error al traer productos de este género.");
          setProducts([]);
          setTotalPages(0);
        } else {
          // Set products from the response
          const genreProducts = response.docs || [];
          setProducts(genreProducts);

          // Calculate totalPages if not provided by API
          const apiTotalPages = response.totalPages || 0;
          const calculatedTotalPages = response.totalDocs ? Math.ceil(response.totalDocs / 12) : apiTotalPages;
          setTotalPages(calculatedTotalPages);

          // Log result for debugging
          console.log(`Fetched ${genreProducts.length} products for genre: ${slug} (page ${currentPage}/${calculatedTotalPages})`);

          if (genreProducts.length === 0 && currentPage === 1) {
            console.log("No products found for genre:", slug);
          }
        }

      } catch (error) {
        console.error("Error fetching genre products:", error);
        alert.error("Hubo un error al cargar los productos.");
        setProducts([]);
        setTotalPages(0);
      } finally {
        setLoading(false);
      }
    };

    fetchGenreProducts();
  }, [slug, currentPage, userCountry]);

  // Fetch ALL products for filtering (separate from pagination)
  console.log(userCountry);


  // useEffect(() => {
  //   const fetchAllGenreProducts = async () => {
  //     try {
  //       // Fetch ALL products for filtering purposes
  //       const response = await getAllGenreProducts("mujer", "mx");

  //       if (response?.error) {
  //         console.error("Error fetching all genre products for filtering:", response.message);
  //         setAllProducts([]);
  //       } else {
  //         const allGenreProducts = response.docs || [];
  //         setAllProducts(allGenreProducts);
  //         console.log(`Fetched ${allGenreProducts.length} total products for filtering`);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching all genre products for filtering:", error);
  //       setAllProducts([]);
  //     }
  //   };

  //   fetchAllGenreProducts();
  // }, [slug, userCountry]);

  // Fetch genre data
  useEffect(() => {
    const fetchGenreData = async () => {
      try {
        const response = await getGenre(slug);
        if (response?.error) {
          console.error("Error fetching genre:", response.message);
          alert.error("Hubo un error al traer información de este género.");
        } else {
          setGenre(response.docs?.[0] || null);
        }
      } catch (error) {
        console.error("Error fetching genre:", error);
        alert.error("Hubo un error al cargar el género.");
      } finally {
        setLoadingGenre(false);
      }
    };

    fetchGenreData();
  }, [slug]);

  const allFilterClickListener = (e, filterProp) => {
    // console.log("FILTER clicked", e);
    const name = e;
    setTestingState((prevState) => ({
      passingTags: {
        ...prevState.passingTags,
        [filterProp]: {
          ...prevState.passingTags[filterProp],
          [name]: !prevState.passingTags[filterProp][name],
        },
      },
    }));
  };

  const filteredCollected = () => {
    const collectedTrueKeys = {
      calibre: [],
      tipoCorrea: [],
      marca: [],
      tipo: [],
      condicion: [],
      caratula: [],
      carcasa: [],
    };
    const { calibre, genero, condicion, marca, tipo, tipoCorrea, caratula, carcasa } =
      testinState.passingTags;
    for (let calibreKey in calibre) {
      if (calibre[calibreKey]) collectedTrueKeys.calibre.push(calibreKey);
    }
    for (let marcaKey in marca) {
      if (marca[marcaKey]) collectedTrueKeys.marca.push(marcaKey);
    }
    for (let tipoCorreaKey in tipoCorrea) {
      if (tipoCorrea[tipoCorreaKey])
        collectedTrueKeys.tipoCorrea.push(tipoCorreaKey);
    }
    for (let tipoKey in tipo) {
      if (tipo[tipoKey]) collectedTrueKeys.tipo.push(tipoKey);
    }
    for (let condicionKey in condicion) {
      if (condicion[condicionKey])
        collectedTrueKeys.condicion.push(condicionKey);
    }
    for (let caratulaKey in caratula) {
      if (caratula[caratulaKey])
        collectedTrueKeys.caratula.push(caratulaKey);
    }
    for (let carcasaKey in carcasa) {
      if (carcasa[carcasaKey])
        collectedTrueKeys.carcasa.push(carcasaKey);
    }
    return collectedTrueKeys;
  };

  const multiPropsFilter = (originalProducts, filters) => {
    const filterKeys = Object.keys(filters);
    // console.log(filterKeys);
    let filtered = originalProducts?.filter((product) => {
      return filterKeys.every((key) => {
        // console.log("key", key);
        if (!filters[key].length) return true;

        // Handle special cases for caratula and carcasa
        if (key === 'caratula') {
          return filters[key].includes(product.colorCaratula?.color);
        }
        if (key === 'carcasa') {
          return filters[key].includes(product.materialCarcasa?.material);
        }

        // Handle regular filters
        return filters[key].includes(product[key]?.nombre);
      });
    });

    // Filter by price range (only if we have enough products to show the slider)
    if (filtered && priceRange && allProducts && allProducts.length >= 5) {
      filtered = filtered.filter((product) => {
        const price = parseFloat(product.precio || product.price || 0);
        return price >= priceRange.min && price <= priceRange.max;
      });
    }

    return filtered;
  };

  const searchProducts = () => {
    // Determine if price filter is actively being used
    const isPriceFilterActive = priceRange && allProducts && allProducts.length >= 5;

    // Check if any category filters are active
    const areCategoryFiltersActive = categories.length > 0;

    // If no filters are active at all, return the paginated products
    if (!areCategoryFiltersActive && !isPriceFilterActive) {
      console.log('No filters active, returning paginated products:', products?.length);
      return products || [];
    }

    // Otherwise, filter all products
    console.log('Filters active, filtering all products. Categories:', categories.length, 'Price filter:', isPriceFilterActive);
    const filteredProducts2 = multiPropsFilter(allProducts, filteredCollected());
    return filteredProducts2;
  };

  // Debug: Log when products change
  useEffect(() => {
    console.log('=== PRODUCTS STATE UPDATED ===');
    console.log('Products count:', products?.length);
    console.log('Current page:', currentPage);
    console.log('Total pages:', totalPages);
    console.log('Products:', products);
    console.log('=============================');
  }, [products, currentPage, totalPages]);

  // Trigger filtering when price range changes
  useEffect(() => {
    // This will trigger re-render when price range changes
  }, [priceRange]);

  // console.log(genre);
  // if (loading) {
  //   <section className="brand-catalogue">
  //     <Container>
  //       <p>Cargando...</p>
  //     </Container>
  //   </section>;
  // }
  return (
    <section className="genre-catalogue">
      <section className="products col-12">
        <div className="products__container">
          <div
            className="products__genre__header"
            style={{
              backgroundImage: `linear-gradient(
                   rgba(0, 0, 0, 0.53),
                   rgba(0, 0, 0, 0.275)
                 ), url(${genre?.portada?.url})`,
            }}
          >
            <h3 className="text-capitalize">{genre?.nombre}</h3>
          </div>
          <div className="products__product-container">
            {/* {!loading && data.allProductos?.length > 0 ? (
              data.allProductos.map((product) => (
                <ProductItem key={product.id} product={product} />
              ))
            ) : (
              <p className="products__emtpy">Cargando productos...</p>
            )} */}
            <Row>
              <div className="filters col-12 col-lg-3">
                <div className="filters__container">
                  <div
                    className="filters__header"
                    style={{ cursor: isMobile ? "pointer" : "default" }}
                    onClick={isMobile ? handleMobileFilterToggle : undefined}
                  >
                    <img
                      src={FilterIcon}
                      alt="Filtros"
                      className="filters__icon"
                    />
                    <p className="filters__title">Filtros</p>
                    {isMobile && (
                      <span
                        className="d-block d-lg-none ms-3"
                        style={{ fontSize: "1.1rem", fontWeight: "bolder" }}
                      >
                        {isMobileFilterOpen
                          ? "Toca para ocultar"
                          : "Toca para expandir filtros"}
                      </span>
                    )}
                  </div>
                  <div className={`filters__filter-container ${isMobile ? (isMobileFilterOpen ? "show" : "") : ""}`}>
                    <div
                      className="filters__filter filters__filter--clear filter__item"
                      data-filter="all"
                    >
                      <div className="filters__filter__content">
                        <p
                          className="filters__filter__name filters__filter__name--small"
                          onClick={() => {
                            const selectedFilter = document.querySelectorAll(
                              ".filters__filter__dropdown-menu__item__name"
                            );
                            selectedFilter.forEach((filter) =>
                              filter.classList.remove("active")
                            );
                            setCategories([]);
                            setTestingState(state);
                            setFilterResetTrigger(prev => prev + 1);
                          }}
                        >
                          Limpiar filtros <i className="far fa-times"></i>
                        </p>
                      </div>
                    </div>

                    {/* Price Range Slider - Only show if 5+ products */}
                    {allProducts && allProducts.length >= 5 && (
                      <PriceRangeSlider
                        products={allProducts}
                        onPriceChange={setPriceRange}
                        resetTrigger={filterResetTrigger}
                      />
                    )}

                    <div className={`filters__filter filters__filter--dropdown ${openDropdowns.correa ? 'open' : ''}`}>
                      <div className="filters__filter__content">
                        <p
                          className="filters__filter__name"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleDropdown('correa');
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          Correa
                        </p>
                        <div className={`filters__filter__dropdown-menu ${openDropdowns.correa ? 'open' : ''}`}>
                          <ul className="filters__filter__dropdown-menu__item-container">
                            {getUniqueWatchBands().map((band, key) => (
                              <li
                                className="filters__filter__dropdown-menu__item filter__item"
                                data-filter={band.toLowerCase()}
                                key={key}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  allFilterClickListener(band, "tipoCorrea");
                                  const filtersDropdownMenu =
                                    document.querySelector(
                                      ".filters__filter-container"
                                    );
                                  if (filtersDropdownMenu) {
                                    filtersDropdownMenu.classList.remove("show");
                                  }
                                  e.target.classList.toggle("active");
                                  if (categories.includes(band.toLowerCase())) {
                                    setCategories(
                                      categories.filter(
                                        (category) => category !== band.toLowerCase()
                                      )
                                    );
                                  } else {
                                    setCategories([...categories, band.toLowerCase()]);
                                  }

                                  // Close mobile filter menu after selection
                                  if (isMobile && isMobileFilterOpen) {
                                    setTimeout(() => {
                                      setIsMobileFilterOpen(false);
                                    }, 300);
                                  }
                                }}
                              >
                                <p className="filters__filter__dropdown-menu__item__name text-capitalize">
                                  {band}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className={`filters__filter filters__filter--dropdown ${openDropdowns.marca ? 'open' : ''}`}>
                      <div className="filters__filter__content">
                        <p
                          className="filters__filter__name"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleDropdown('marca');
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          Marca
                        </p>
                        <div className={`filters__filter__dropdown-menu ${openDropdowns.marca ? 'open' : ''}`}>
                          <ul className="filters__filter__dropdown-menu__item-container">
                            {getUniqueBrands().map((brand, key) => (
                              <li
                                className="filters__filter__dropdown-menu__item filter__item"
                                data-filter={brand.toLowerCase()}
                                key={key}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  allFilterClickListener(brand, "marca");
                                  const filtersDropdownMenu =
                                    document.querySelector(
                                      ".filters__filter-container"
                                    );
                                  if (filtersDropdownMenu) {
                                    filtersDropdownMenu.classList.remove("show");
                                  }
                                  e.target.classList.toggle("active");

                                  if (categories.includes(brand.toLowerCase())) {
                                    setCategories(
                                      categories.filter(
                                        (category) => category !== brand.toLowerCase()
                                      )
                                    );
                                  } else {
                                    setCategories([...categories, brand.toLowerCase()]);
                                  }
                                }}
                              >
                                <p className="filters__filter__dropdown-menu__item__name text-capitalize">
                                  {brand}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className={`filters__filter filters__filter--dropdown ${openDropdowns.condicion ? 'open' : ''}`}>
                      <div className="filters__filter__content">
                        <p
                          className="filters__filter__name"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleDropdown('condicion');
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          Condición
                        </p>
                        <div className={`filters__filter__dropdown-menu ${openDropdowns.condicion ? 'open' : ''}`}>
                          <ul className="filters__filter__dropdown-menu__item-container">
                            {getUniqueWatchConditions().map((condition, key) => (
                              <li
                                className="filters__filter__dropdown-menu__item filter__item"
                                data-filter={condition.toLowerCase()}
                                key={key}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  allFilterClickListener(condition, "condicion");
                                  const filtersDropdownMenu =
                                    document.querySelector(
                                      ".filters__filter-container"
                                    );
                                  if (filtersDropdownMenu) {
                                    filtersDropdownMenu.classList.remove("show");
                                  }
                                  e.target.classList.toggle("active");
                                  if (categories.includes(condition.toLowerCase())) {
                                    setCategories(
                                      categories.filter(
                                        (category) => category !== condition.toLowerCase()
                                      )
                                    );
                                  } else {
                                    setCategories([...categories, condition.toLowerCase()]);
                                  }
                                }}
                              >
                                <p className="filters__filter__dropdown-menu__item__name text-capitalize">
                                  {condition}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className={`filters__filter filters__filter--dropdown ${openDropdowns.tipo ? 'open' : ''}`}>
                      <div className="filters__filter__content">
                        <p
                          className="filters__filter__name"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleDropdown('tipo');
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          Tipo
                        </p>
                        <div className={`filters__filter__dropdown-menu ${openDropdowns.tipo ? 'open' : ''}`}>
                          <ul className="filters__filter__dropdown-menu__item-container">
                            {getUniqueWatchTypes().map((type, key) => (
                              <li
                                className="filters__filter__dropdown-menu__item filter__item"
                                data-filter={type.toLowerCase()}
                                key={key}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  allFilterClickListener(type, "tipo");
                                  const filtersDropdownMenu =
                                    document.querySelector(
                                      ".filters__filter-container"
                                    );
                                  if (filtersDropdownMenu) {
                                    filtersDropdownMenu.classList.remove("show");
                                  }
                                  e.target.classList.toggle("active");

                                  if (categories.includes(type.toLowerCase())) {
                                    setCategories(
                                      categories.filter(
                                        (category) => category !== type.toLowerCase()
                                      )
                                    );
                                  } else {
                                    setCategories([...categories, type.toLowerCase()]);
                                  }
                                }}
                              >
                                <p className="filters__filter__dropdown-menu__item__name">
                                  {type}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className={`filters__filter filters__filter--dropdown ${openDropdowns.calibre ? 'open' : ''}`}>
                      <div className="filters__filter__content">
                        <p
                          className="filters__filter__name"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleDropdown('calibre');
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          Calibre
                        </p>
                        <div className={`filters__filter__dropdown-menu ${openDropdowns.calibre ? 'open' : ''}`}>
                          <ul className="filters__filter__dropdown-menu__item-container">
                            {getUniqueWatchCalibers().map((caliber, key) => (
                              <li
                                className="filters__filter__dropdown-menu__item filter__item"
                                data-filter={caliber.toLowerCase()}
                                key={key}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  allFilterClickListener(caliber, "calibre");
                                  const filtersDropdownMenu =
                                    document.querySelector(
                                      ".filters__filter-container"
                                    );
                                  if (filtersDropdownMenu) {
                                    filtersDropdownMenu.classList.remove("show");
                                  }
                                  e.target.classList.toggle("active");

                                  if (categories.includes(caliber.toLowerCase())) {
                                    setCategories(
                                      categories.filter(
                                        (category) => category !== caliber.toLowerCase()
                                      )
                                    );
                                  } else {
                                    setCategories([...categories, caliber.toLowerCase()]);
                                  }
                                }}
                              >
                                <p className="filters__filter__dropdown-menu__item__name">
                                  {caliber}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* NEW: Caratula (Dial Color) Filter */}
                    <div className={`filters__filter filters__filter--dropdown ${openDropdowns.caratula ? 'open' : ''}`}>
                      <div className="filters__filter__content">
                        <p
                          className="filters__filter__name"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleDropdown('caratula');
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          Color de Carátula
                        </p>
                        <div className={`filters__filter__dropdown-menu ${openDropdowns.caratula ? 'open' : ''}`}>
                          <ul className="filters__filter__dropdown-menu__item-container">
                            {getUniqueCaratulas().map((caratula, key) => (
                              <li
                                className="filters__filter__dropdown-menu__item filter__item"
                                data-filter={caratula.toLowerCase()}
                                key={key}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  allFilterClickListener(caratula, "caratula");
                                  const filtersDropdownMenu =
                                    document.querySelector(
                                      ".filters__filter-container"
                                    );
                                  if (filtersDropdownMenu) {
                                    filtersDropdownMenu.classList.remove("show");
                                  }
                                  e.target.classList.toggle("active");
                                  if (categories.includes(caratula.toLowerCase())) {
                                    setCategories(
                                      categories.filter(
                                        (category) => category !== caratula.toLowerCase()
                                      )
                                    );
                                  } else {
                                    setCategories([...categories, caratula.toLowerCase()]);
                                  }
                                }}
                              >
                                <p className="filters__filter__dropdown-menu__item__name">
                                  {caratula}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* NEW: Carcasa (Case Material) Filter */}
                    <div className={`filters__filter filters__filter--dropdown ${openDropdowns.carcasa ? 'open' : ''}`}>
                      <div className="filters__filter__content">
                        <p
                          className="filters__filter__name"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleDropdown('carcasa');
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          Material de Carcasa
                        </p>
                        <div className={`filters__filter__dropdown-menu ${openDropdowns.carcasa ? 'open' : ''}`}>
                          <ul className="filters__filter__dropdown-menu__item-container">
                            {getUniqueCarcasas().map((carcasa, key) => (
                              <li
                                className="filters__filter__dropdown-menu__item filter__item"
                                data-filter={carcasa.toLowerCase()}
                                key={key}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  allFilterClickListener(carcasa, "carcasa");
                                  const filtersDropdownMenu =
                                    document.querySelector(
                                      ".filters__filter-container"
                                    );
                                  if (filtersDropdownMenu) {
                                    filtersDropdownMenu.classList.remove("show");
                                  }
                                  e.target.classList.toggle("active");
                                  if (categories.includes(carcasa.toLowerCase())) {
                                    setCategories(
                                      categories.filter(
                                        (category) => category !== carcasa.toLowerCase()
                                      )
                                    );
                                  } else {
                                    setCategories([...categories, carcasa.toLowerCase()]);
                                  }
                                }}
                              >
                                <p className="filters__filter__dropdown-menu__item__name">
                                  {carcasa}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="brand-catalogue__products col-12 col-lg-9">
                <Row>
                  {loading ? (
                    <p className="pt-3">Cargando productos...</p>
                  ) : (
                    <>
                      {searchProducts().length > 0 ? (
                        searchProducts().map((product, key) => (
                          <ProductCard
                            product={product}
                            key={key}
                            loading={loading}
                          />
                        ))
                      ) : (
                        <p className="py-3">
                          {(categories.length > 0 || (priceRange && allProducts && allProducts.length >= 5))
                            ? "No se encontraron relojes con los filtros seleccionados."
                            : "No se encontraron relojes de este género."}
                        </p>
                      )}
                    </>
                  )}
                </Row>

                {/* Show pagination when not filtering and there are multiple pages */}
                {!loading && totalPages > 1 && categories.length === 0 && !(priceRange && allProducts && allProducts.length >= 5) && (
                  <div className="d-flex justify-content-center mt-4">
                    <CustomPagination
                      totalPages={totalPages}
                      currentPage={currentPage}
                      paginate={(page) => setCurrentPage(page)}
                      hasNextPage={currentPage < totalPages}
                      hasPrevPage={currentPage > 1}
                    />
                  </div>
                )}
              </div>
            </Row>
          </div>
        </div>
      </section>
    </section>
  );
}
